import script from "./Sound.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sound.vue?vue&type=script&setup=true&lang=ts"

import "./Sound.vue?vue&type=style&index=0&id=63e49e66&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e49e66"]])

export default __exports__